import { DrawingAnswer } from "shared/types/studentTypes"
import { SectionProgressType } from "../AssignmentTopic"
import { parseFormData } from "helpers/formDataHelper"
import { ASSESSMENT_RESPONSES_LOCAL_KEY } from "constants/assignmentConstants"

export const saveDemoAssessmentResponses = ({ drawingResponses } :  { drawingResponses: Record<string, DrawingAnswer>}) => {
    const form = document.getElementById("assessment-form") as HTMLFormElement
    const data = {...parseFormData(form, false), ...drawingResponses}
    localStorage.setItem(ASSESSMENT_RESPONSES_LOCAL_KEY, JSON.stringify(data))
}

export const checkIfAssessmentComplete = (form: HTMLFormElement, drawingResponsesNo?: number): [boolean, string] => {
    if(!form) {
        return [false, "Could not verify the assessment. Please contact STEM Sims support."]
    }
    const questionGroups = form.querySelectorAll(".question-group")
    const formElements = form.elements
    const radios = [...formElements]

    const validNodePattern = /^q\d+a\d+$/
    const checkedRadios = radios.filter(node => node["checked"] && validNodePattern.test(node.id))
    if (questionGroups.length > (checkedRadios.length + (drawingResponsesNo ?? 0))) {
        return [false, "Please fill out the entire assessment before submitting"]
    }
    return [true, "Assessment is completed."]
}

export const checkIfAssessmentSubmissionIsComplete = (assessmentSubmission: Record<string, string>): SectionProgressType => {
    if (!assessmentSubmission) return

    let hasValue = false
    let hasEmptyValue = false

    for (let key of Object.keys(assessmentSubmission)) {
        if (assessmentSubmission[key]) {
            hasValue = true
        } else {
            hasEmptyValue = true
        }

        if (hasValue && hasEmptyValue) {
            return "incomplete"
        }
    }
    return hasValue ? "complete" : "not-visited"
}

export const getUnansweredQuestions = (form: HTMLFormElement, drawingResponses: Record<string, DrawingAnswer>): string[] => {
    if(!form) {
        return
    }

    const questionNumbers = [...form.querySelectorAll(".question-group")].map(qg => qg.id)
    const formElements = form.elements
    const radios = [...formElements]

    const unanswered = []

    const validNodePattern = /^q\d+a\d+$/
    const checkedRadios = radios.filter(node => node["checked"] && validNodePattern.test(node.id))
    const answered = checkedRadios.map(radio => {
        const a = document.getElementById(radio.id)
        const questionNum = a.dataset["qNo"]
        return questionNum
    })

    for (let drawingRes of Object.keys(drawingResponses)) {
        answered.push(drawingRes.split('-')[1])
    }

    // Only get the question numbers that are not in the answered array
    for (let i of questionNumbers) {
        if (!answered.includes(i.toString())) {
            unanswered.push(i.toString())
        }
    }

    return unanswered
}
